/* Mystic Zoo — accessible product artwork gallery.
   Uses only the customer-facing product media supplied by Shopify. */
(() => {
  if (window.MysticZooProductGalleryBound) return;
  window.MysticZooProductGalleryBound = true;

  const getGallery = (node) => node.closest('[data-mz-artwork-gallery]');

  const setActiveArtwork = (gallery, trigger) => {
    const mainImage = gallery.querySelector('[data-mz-main-image]');
    const zoomImage = gallery.querySelector('[data-mz-zoom-image]');
    if (!mainImage || !trigger) return;

    const { fullSrc, fullSrcset, alt, mediaId, width, height, mzFrameStyle: frameStyle } = trigger.dataset;
    if (!fullSrc) return;

    mainImage.src = fullSrc;
    if (fullSrcset) mainImage.srcset = fullSrcset;
    else mainImage.removeAttribute('srcset');
    if (alt) mainImage.alt = alt;
    if (width) mainImage.width = Number(width);
    if (height) mainImage.height = Number(height);
    mainImage.dataset.mzCurrentMediaId = mediaId || '';

    const artworkFrame = gallery.querySelector('[data-mz-artwork-frame]');
    if (artworkFrame) artworkFrame.dataset.mzFrameStyle = frameStyle || 'none';

    if (zoomImage) {
      zoomImage.src = fullSrc;
      if (alt) zoomImage.alt = alt;
    }

    gallery.querySelectorAll('[data-mz-thumbnail]').forEach((thumbnail) => {
      const isCurrent = thumbnail === trigger;
      thumbnail.classList.toggle('is-current', isCurrent);
      thumbnail.setAttribute('aria-pressed', String(isCurrent));
    });
  };

  const closeZoom = (dialog) => {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
  };

  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('[data-mz-thumbnail]');
    if (thumbnail) {
      event.preventDefault();
      const gallery = getGallery(thumbnail);
      if (gallery) setActiveArtwork(gallery, thumbnail);
      return;
    }

    const mainArtwork = event.target.closest('[data-mz-main-image]');
    if (mainArtwork) {
      const gallery = getGallery(mainArtwork);
      const dialog = gallery?.querySelector('[data-mz-zoom-dialog]');
      if (!dialog) return;
      if (typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
      else dialog.setAttribute('open', '');
      return;
    }

    const openTrigger = event.target.closest('[data-mz-zoom-open]');
    if (openTrigger) {
      event.preventDefault();
      const gallery = getGallery(openTrigger);
      const dialog = gallery?.querySelector('[data-mz-zoom-dialog]');
      if (!dialog) return;
      if (typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
      else dialog.setAttribute('open', '');
      return;
    }

    const closeTrigger = event.target.closest('[data-mz-zoom-close]');
    if (closeTrigger) {
      event.preventDefault();
      closeZoom(closeTrigger.closest('[data-mz-zoom-dialog]'));
      return;
    }

    const dialog = event.target.closest('[data-mz-zoom-dialog]');
    if (dialog && event.target === dialog) closeZoom(dialog);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-mz-zoom-dialog][open]').forEach(closeZoom);
  });
})();
